// FIXME: these routes do not follow the rest of the app guidelines
// TODO: enforce /path/:action/:id
export const paths = [
  '/projects/:projectId/field-notes',
  '/projects/:projectId/field-notes/:action',
  '/projects/:projectId/field-notes/:action/:fieldNoteId',
];
